










































































import Confirmacao from '@/components/ui/Confirmacao.vue'
import { ItemDeRomaneioForm, Romaneio, RomaneioForm } from '@/models/Romaneio'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { RomaneioEstoqueUseCase } from '@/usecases/loja/RomaneioEstoqueUseCase'
import { Component, Ref, Vue } from 'vue-property-decorator'
import DialogoDoDetalhesDaTransferencia from './DialogoDoDetalhesDaTransferencia.vue'

@Component({
	components: {
		DialogoDoDetalhesDaTransferencia,
		Confirmacao,
	},
})
export default class DialogoDeTranferenciaDeEstoque extends Vue {
	@Ref() readonly detalhesTranferencia!: DialogoDoDetalhesDaTransferencia
	@Ref() confirmacaoDaMovimentacao!: Confirmacao
	mostra = false
	romaneio: Romaneio[] = []
	itemRomaneio: ItemDeRomaneioForm[] = []
	romaneioEstoqueUseCase = new RomaneioEstoqueUseCase()
	depositoId: string | null = null
	buscando = false

	headers = [
		{ text: 'Identificador', value: 'sequenciaNumerica' },
		{ text: 'Status', value: 'statusRomaneio' },
		{ text: 'Data e Hora', value: 'dataHoraCriacao' },
		{ text: 'Tipo de movimentação', value: 'tipoMovimentacaoRomaneio' },
		{ text: 'observacao de Romaneio', value: 'observacaoRomaneio' },
		{ text: 'Ações', value: 'actions' },
	]

	dateTimeToPtBrFormat = dateTimeToPtBrFormat

	get itensFormatados() {
		
		return this.romaneio.map(romaneio => ({
			...romaneio,
			dataHoraCriacao: !romaneio.dataHoraCriacao ? '-' : dateTimeToPtBrFormat(romaneio.dataHoraCriacao),
			observacaoRomaneio: romaneio.observacaoRomaneio 
				? romaneio.observacaoRomaneio 
				: 'Sem Observação',
		}))
	}

	formatarMenssagem(romaneioSelecionado: Romaneio) {
		if(romaneioSelecionado.zerarTodoEstoque == true) {
			return `
					<div><h2 class="formatarAviso">Aviso!</h2></div>
					<div class="mt-4">
						Essa movimentação está com a opção "zerar todo estoque" selecionada.
						Esse processo irá zerar todo estoque dos produtos ausentes na lista.
					</div>
					<div class="d-flex justify-end mt-8" style="font-size: 11px">${'Identificador: ' + romaneioSelecionado.sequenciaNumerica}</div>
				`
		} 
		return `<div>${'Identificador: ' + romaneioSelecionado.sequenciaNumerica}</div>`
	}

	async mostrar(idDeposito?: string) {
		this.depositoId = idDeposito || null
		this.mostra = true
		this.buscarRomaneiosPendentes()
	}

	async buscarRomaneiosPendentes() {
		if(!this.depositoId) return
		this.buscando = true
		try {
			const itemRomaneioListagem = 
				await this.romaneioEstoqueUseCase.findRomaneioPendente(this.depositoId)
			this.romaneio = itemRomaneioListagem.content
		} catch(error) {
			AlertModule.setError(error)
		} finally {
			this.buscando = false
		}
	}

	async confirmar(romaneioSelecionado: Romaneio) {
		this.buscando = true
		romaneioSelecionado.itens.forEach(item => {
			this.itemRomaneio.push({
				id: item.id,
				produto: item.produto.id,
				quantidade: item.quantidade,
			})
		})

		const romaneio: RomaneioForm = {
			id: romaneioSelecionado.id || "",
			sequenciaNumerica: romaneioSelecionado.sequenciaNumerica || 0,
			tipoMovimentacaoRomaneio: romaneioSelecionado.tipoMovimentacaoRomaneio,
			usuarioCrio: romaneioSelecionado.usuarioCrio.id || "",
			usuarioConfirmou: "",
			statusRomaneio: "Confirmado",
			deposito: romaneioSelecionado.deposito.id || "",
			dataHoraCriacao: new Date(),
			itens: this.itemRomaneio,
			depositoDestino: romaneioSelecionado.depositoDestino.id || "",
			observacaoRomaneio: romaneioSelecionado.observacaoRomaneio || "",
			zerarTodoEstoque: romaneioSelecionado.zerarTodoEstoque || false,
		}

		try {
			await this.romaneioEstoqueUseCase.update(romaneio)
		} catch (error) {
			AlertModule.setMessage(error)
		} finally {
			this.mostra = false
			this.buscando = false
			if(romaneio.tipoMovimentacaoRomaneio == "Balanco"){
				AlertModule.setSuccess('Balanço em processamento') 
			}
			else{
				AlertModule.setSuccess('Transferência feita com sucesso') 
			}
		}
	}
}
